<template>
  <v-dialog v-model="newClassRemark.dialog" max-width="616px">
    <v-card v-if="!isLoading">
      <v-card-title class="title blue-title pa-3 pt-4 ml-2">
        Class Remarks
        <div class="header-close" title="close" @click="newClassRemark.dialog = false">
          <v-icon>close</v-icon>
        </div>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md pt-0 px-2>
          <v-layout wrap>
             <!-- 易起口语杯赛事测评课 教材id-1290 易建联星火项目 -->
            <v-flex xs12 mb-2 v-if="info.IsShowScore">
              <v-card-title class="pl-0 pb-0 pt-0 blue-text-normal">
                  <label class="blue-title-2">Learning objectives assessment</label>
              </v-card-title>
              <v-layout>
                <v-flex xs3 v-for="(item,index) in objectivesList" :key="item">
                  <v-btn class="text-none objectives-btn" 
                        :class="classRemarksForm.EvaluationState===index+2?'red-button':'red-border-button'" 
                        @click="classRemarksForm.EvaluationState=index+2">{{item}}</v-btn>
                </v-flex>
              </v-layout>
              <p v-if="$v.classRemarksForm.EvaluationState.$error" class="pink-text">Required</p>
            </v-flex>
            <v-flex xs12>
              <v-card-title class="pl-0 pb-0 pt-0 blue-text-normal">
                  <label class="blue-title-2">Students Grasp the Situation</label>
              </v-card-title>
              <v-flex xs12>
                  <span class="blue-text-normal">Please select the items that students have <span class="pink-text">not mastered</span></span>
              </v-flex>
              <v-card-title class="pl-0 pb-0 pt-2 blue-title font-weight-regular">
                <label>Word</label>
              </v-card-title>
              <v-layout class="pr-3 pt-2">
                <v-flex xs12>
                  <ul class="select-body">
                    <li v-for="(item, $index) in wordList" :key="$index" @click="selectStyle(item, $index, wordList)" :class="item.ischecked ? 'ischecked' : ''">
                      <!-- <span class="mastered-tip" v-if="item.ischecked">Not Mastered</span> -->
                      {{ item.text }}
                    </li>
                  </ul>
                </v-flex>
              </v-layout>

              <v-card-title class="pl-0 pb-0 pt-2 blue-title font-weight-regular">
                <label>Phonics</label>
              </v-card-title>
              <v-layout class="pr-3 pt-2">
                <v-flex xs12>
                  <ul class="select-body">
                    <li v-for="(item, $index) in phonicsList" :key="$index" @click="selectStyle(item, $index, phonicsList)" :class="item.ischecked ? 'ischecked' : ''">
                      <!-- <span class="mastered-tip" v-if="item.ischecked">Not Mastered</span> -->
                      {{ item.text }}
                    </li>
                  </ul>
                </v-flex>
              </v-layout>

              <v-card-title class="pl-0 pb-0 pt-2 blue-title font-weight-regular">
                <label>Phrase</label>
              </v-card-title>
              <v-layout class="pr-3 pt-2">
                <v-flex xs12>
                  <ul class="select-body">
                    <li v-for="(item, $index) in phraseList" :key="$index" @click="selectStyle(item, $index, phraseList)" :class="item.ischecked ? 'ischecked' : ''">
                      <!-- <span class="mastered-tip" v-if="item.ischecked">Not Mastered</span> -->
                      {{ item.text }}
                    </li>
                  </ul>
                </v-flex>
              </v-layout>

              <v-card-title class="pl-0 pb-0 pt-2 blue-title font-weight-regular">
                <label>Grammar</label>
              </v-card-title>
              <v-layout class="pt-2">
                <v-flex xs12>
                  <ul class="select-body on-column">
                    <li v-for="(item, $index) in grammarList" :key="$index" @click="selectStyle(item, $index, grammarList)" :class="item.ischecked ? 'ischecked' : ''">
                      <!-- <span class="mastered-tip" v-if="item.ischecked">Not Mastered</span> -->
                      {{ item.text }}
                    </li>
                  </ul>
                </v-flex>
              </v-layout>

              <v-card-title class="pl-0 pb-0 pt-2 blue-title font-weight-regular">
                <label>Key Sentence</label>
              </v-card-title>
              <v-layout class="pr-3 pt-2">
                <v-flex xs12>
                  <ul class="select-body on-column">
                    <li v-for="(item, $index) in keySentenceList" :key="$index" @click="selectStyle(item, $index, keySentenceList)" :class="item.ischecked ? 'ischecked' : ''">
                      <!-- <span class="mastered-tip" v-if="item.ischecked">Not Mastered</span> -->
                      {{ item.text }}
                    </li>
                  </ul>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex xs12>
              <v-card-title class="pl-0 pt-4">
                <label class="blue-title-2">Performance of Class</label>
              </v-card-title>

              <v-layout>
                <v-flex xs12>
                  <v-layout class="align-center" v-for="(item, index) in starList2" :key="index" nowrap>
                    <v-flex xs12>
                      <rateStar class="py-0"
                                :title="item.title" :descriptions="item.descriptions"
                                v-model="classRemarksForm.rates[item.title]"
                                @input="$v.classRemarksForm.rates[item.title].$touch()" />
                    </v-flex>
                    <span class="error--text"
                          v-if="$v.classRemarksForm.rates[item.title].$error">Required</span>
                  </v-layout>
                </v-flex>
              </v-layout>

            </v-flex>

            <v-flex xs12 v-if="wonderfulPictures && wonderfulPictures.length">
              <v-card-title class="pl-0 pb-0 pt-4">
                <p class="blue-title-2"><label>Classroom Highlights</label></p>
              </v-card-title>
              <v-flex class="display-flex flex-wrap">
                <div v-for="item in wonderfulPictures" :key="item.Id" class="w-picture-card">
                  <v-icon class="picture-close" @click="hidePicture(item.Id)">close</v-icon>
                  <a :href="item.ImagePath" target="_blank">
                    <img :src="item.ImagePath" alt="">
                  </a>
                </div>
              </v-flex>
            </v-flex>

            <v-flex xs12>
              <v-card-title class="pl-0 pb-0 pt-4">
                <label class="blue-title-2">Assessment for Class</label>
              </v-card-title>
              <v-flex xs12>
                <span class="blue-text-normal">Make the assessment consitstent with your in-class comment for the student.</span>
              </v-flex>
              <v-layout>
                <v-flex>
                  <v-textarea outline single-line name="input-7-4" counter minlength="20" maxlength="800"
                              required
                              :error-messages="descriptionErrors"
                              @input="$v.classRemarksForm.Comments.$touch()"
                              v-model="classRemarksForm.Comments"></v-textarea>
                </v-flex>
              </v-layout>

            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions class="py-4">
        <v-layout row>
            <v-flex xs12 class="text-xs-center">
              <v-btn class="text-none red-button dialog-submit"
                    :loading="submitting"
                    @click="submit">Submit</v-btn>
              <v-btn class="text-none cancel-button"
                    @click="newClassRemark.dialog=false">Cancel</v-btn>
            </v-flex>
          </v-layout>
      </v-card-actions>
    </v-card>
    <v-card v-if="isLoading">
      <v-flex xs12 text-xs-center mt-4 pt-4 class="pr-3 pb-4">
        <v-progress-circular indeterminate :size="50" class="blue-title-2"></v-progress-circular>
      </v-flex>
    </v-card>
  </v-dialog>
</template>
<script>
  import { knowledgePointsClassRemark, GetCoursewareKnowledgePointBySId, GetUserUserReportByID, GetWonderfulPictures } from '@/api/classtable.js'
  import rateStar from './rateStar'
  import { createNamespacedHelpers } from 'vuex'
  import vmodel from '@/mixins/v-model'
  import { validationMixin } from 'vuelidate'
  import { required, minValue, minLength, requiredIf } from 'vuelidate/lib/validators'
  import { _debounce } from '@/utils/tools.js'

  const namespace = 'classDetail'
  const { mapGetters, mapActions } = createNamespacedHelpers(namespace)

  export default {
    computed: {
      ...mapGetters(['info', 'currentLesson', 'remarkInfo']),
      descriptionErrors() {
        const errors = []
        if (!this.$v.classRemarksForm.Comments.$dirty) return errors
        !this.$v.classRemarksForm.Comments.minLength && errors.push('At least 20 characters')
        !this.$v.classRemarksForm.Comments.required && errors.push('Required.')
        return errors
      }
    },
    name: 'classRemarks',
    mixins: [vmodel, validationMixin],
    validations() {
      return {
        classRemarksForm: {
          // Sentences: { required },
          Comments: { required, minLength: minLength(20) },
          rates: {
            Interest: { minValue: minValue(1) },
            Confidence: { minValue: minValue(1) }
          },
          EvaluationState: { required: requiredIf(function() {
                return this.info.IsShowScore
            }) 
          }
        }
      }
    },
    data: () => ({
      classRemarksForm: {
        description: '',
        Vocabularies: '',
        Comments: '',
        rates: {
          'Interest': 0,
          'Confidence': 0
        },
        GraspsOfSituation: [
          {
            'Word': []
          },
          {
            'Phonics': []
          },
          {
            'Phrase': []
          },
          {
            'Grammar': []
          },
          {
            'KeySentence': []
          }
        ],
        ReportID: 0,
        EvaluationState:''
      },
      wordKey: '',
      isLoading: false,
      starList2: [
        {
          title: 'Interest',
          descriptions: [
            'The student shows absolutely no interest in learning/ refuses to follow instructions/ has behavior problems.',
            'The student is not interested in learning/ hardly follows instructions/ constantly distracted.',
            'The student is able to follow instructions, stays focused most of the time, however, doesn\'t seem to be excited/happy.',
            'The student is interested in learning, gives his/her full attention, seems to enjoy the class and feel excited.',
            'The student shows great interest in learning, is eager to learn, actively participates in the class and enjoys interacting with the teacher.'
          ]
        },
        {
          title: 'Confidence',
          descriptions: [
            'The student feels extremely shy to speak/  seems afraid to talk to the teacher in English.',
            'The student feels a little bit shy to speak English, however, is able to read/answer questions with teacher\'s encourragement.',
            'The student feels comfortable reading the lesson material, is able to speak English somewhat confidently, however, only when he/she is familiar with the topic.',
            'The student can speak English confidently most of the time, however, still feels a little bit afraid of making mistakes/asking questions/expressing ideas.',
            'The student can speak English confidently/ is not afraid of making mistakes/ asks a lot of questions and enjoys expressing her/his ideas in English.'
          ]
        }
      ],
      wordList: [],
      phonicsList: [],
      phraseList: [],
      grammarList: [],
      keySentenceList: [],
      submitting:false,
      wonderfulPictures: [],
      objectivesList:['Failed','General','Good','Excellent']
    }),
    props: {
      newClassRemark: {
        dialog: false
      }
    },
    components: {
      rateStar
    },
    methods: {
      ...mapActions(['fetchMeterials']),
      GetRemarkInfo(sid, usid) {
        this.isLoading = true
        if (this.info.AllowLeaveRemark == 1) {
          this.getKnowledgePoint(sid)
        } else {
          this.getUserReport(sid, usid)
        }
        this.GetWonderfulPictures(this.info.CLID)
      },
      getKnowledgePoint(sid) {
        GetCoursewareKnowledgePointBySId(sid).then(res => {
          if (!res) {
            this.isLoading = false
            return
          }
          this.wordList = res.AWordInfo ? JSON.parse(res.AWordInfo) : []
          this.phonicsList = res.NaturalSpellingInfo ? JSON.parse(res.NaturalSpellingInfo) : []
          this.phraseList = res.PhraseInfo ? JSON.parse(res.PhraseInfo) : []
          this.grammarList = res.GrammarInfo ? JSON.parse(res.GrammarInfo) : []
          this.keySentenceList = res.CoreSentenceInfo ? JSON.parse(res.CoreSentenceInfo) : []
          this.wordList = this.wordList.map(item => {
            return { text: item.AWord, ischecked: false }
          })
          this.phonicsList = this.phonicsList.map(item => {
            return { text: item.Spelling, ischecked: false }
          })
          this.phraseList = this.phraseList.map(item => {
            return { text: item.Phrase, ischecked: false }
          })
          this.grammarList = this.grammarList.map(item => {
            return { text: item.Grammar, ischecked: false }
          })
          this.keySentenceList = this.keySentenceList.map(item => {
            return { text: item.CSentence, ischecked: false }
          })
          this.isLoading = false
        })
      },
      GetWonderfulPictures(clid){
        GetWonderfulPictures(clid).then(res => {
          this.wonderfulPictures = res
        })
      },
      getUserReport(sid, usid) {
        GetUserUserReportByID(usid).then(res => {
          this.classRemarksForm.Comments = res.Description
          if (res.ReportModel != null) {
            let result = JSON.parse(res.ReportModel.ReportJosn)
            let rates = this.classRemarksForm.rates
            this.classRemarksForm.ReportID = res.ReportModel.ReportID
            this.classRemarksForm.EvaluationState = res.ReportModel.EvaluationState
            rates.Interest = result[0] ? result[0].Score : 0
            rates.Confidence = result[1] ? result[1].Score : 0
            let GraspsOfSituation = res.ReportModel.GraspsOfSituation
            if (GraspsOfSituation) {
              this.wordList = GraspsOfSituation.Word
              this.phonicsList = GraspsOfSituation.Phonics
              this.phraseList = GraspsOfSituation.Phrase
              this.grammarList = GraspsOfSituation.Grammar
              this.keySentenceList = GraspsOfSituation.KeySentence
            } else {
              this.getKnowledgePoint(sid)
            }
          }else {
              this.getKnowledgePoint(sid)
          }
          this.isLoading = false
        })
      },
      submit: _debounce(async function () {
        this.submitting = true
        await this.fetchMeterials()
        this.$v.$touch()
        if (this.$v.$invalid) {
          this.submitting = false
          return
        }
        var pictureIds = [];
        if(this.wonderfulPictures && this.wonderfulPictures.length){
          pictureIds = this.wonderfulPictures.map(item => item.Id)
        }
        var param = {
          UCID: this.info.UCID,
          CLID: this.info.CLID,
          SID: this.currentLesson == null ? this.info.SID : this.currentLesson.SID,
          USID: this.info.USID == null ? this.currentLesson.USID : this.info.USID,
          Comments: this.classRemarksForm.Comments, 
          TrailScore: this.classRemarksForm.rates,
          GraspsOfSituation: {
            'Word': this.wordList,
            'Phonics': this.phonicsList,
            'Phrase': this.phraseList,
            'Grammar': this.grammarList,
            'KeySentence': this.keySentenceList
          },
          PictureIds: pictureIds,
          EvaluationState:this.classRemarksForm.EvaluationState
        }
        knowledgePointsClassRemark(param).then(r => {
          switch (r) {
            case 1:
              this.successTip('Submit success!')
              //this.$toasted.success('Submit success!')
              this.$store.dispatch('classDetail/fetchInfo', this.$route.params.id)
              this.newClassRemark.dialog = false
              break
            case -2:
              this.errorTip('Invalid Data！')
              //this.$toasted.error('Invalid Data！')
              break
            case -11:
              this.errorTip('Error! Please refresh the page and submit it again')
              //this.$toasted.error('Error! Please refresh the page and submit it again')
              break
            case -3:
              this.errorTip('Sorry ! The lesson has not begun!!')
              //this.$toasted.error('Sorry ! The lesson has not begun!!')
              break
            case -4:
              this.errorTip("There's no textbook! Please report to the CS assign the book for the class.")
              //this.$toasted.error("There's no textbook! Please report to the CS assign the book for the class.")
              break
            case -5:
              this.errorTip('Sorry ! Submission is ONLY allowed AFTER the class.')
              //this.$toasted.error('Sorry ! Submission is ONLY allowed AFTER the class.')
              break
            case -6:
              this.errorTip('Sorry ! Please fill in correct test score.')
              //this.$toasted.error('Sorry ! Please fill in correct test score.')
              break
            case -7:
              this.errorTip('Sorry ! Description Do not exceed 500 in length.')
              break
            case -99:
              this.errorTip('Sorry ! Please fill in the complete data.')
              //this.$toasted.error('Sorry ! Please fill in the complete data.')
              break
            default:
              this.errorTip('Sorry ! Please Select a Teaching Material first.')
              //this.$toasted.error('Sorry ! Please Select a Teaching Material first.')
              break
          }
        }).finally(()=>{
          this.submitting = false
        })
      }),
      selectStyle(item, index, array) {
        if (typeof item.ischecked === 'undefined') {
          this.$set(item, 'ischecked', true)
        } else {
          item.ischecked = !item.ischecked
        }
      },
      successTip (msg) {
        return this.$root.$alertTips(msg, 'success')
      },
      errorTip (msg) {
        return this.$root.$alertTips(msg)
      },
      hidePicture(id){
        this.wonderfulPictures.splice(this.wonderfulPictures.findIndex(item => item.Id === id), 1)
      }
    },
    watch: {
      'newClassRemark.dialog': function (value, oldValue) {
        let sid = this.info.SID
        let usid = this.info.USID
        if (value) {
          this.GetRemarkInfo(sid, usid)
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
  .select-body {
    list-style: none;
    padding: 0;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content:space-between;
  }

    .select-body li {
      width: 45%;
      margin: 0 0 4% 0;
      /* align-items: center;     */
      border-radius: 4px;
      /* display: inline-flex; */
      height: 38px;
      line-height: 38px;
      /* flex: 0 0 auto; */
      font-size: 14px;
      font-weight: 500;
      /* justify-content: center; */
      // min-width: 88px;
      outline: 0;
      text-decoration: none;
      transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), #fff 1ms;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      border: 1px solid #EE344C;
      cursor: pointer;
      color: #EE344C;
      font-weight:bold;
      text-align: center;
      position: relative;
    }

      .select-body li.ischecked, .select-body li.ischecked:hover {
        background-color: #EE344C;
        color:#fff;
      }

      .select-body li:before,
      .select-body li:before,
      .select-body li:before {
        background-color: currentColor;
      }

      .select-body li:hover {
        background-color:#EE344C;
        color:#fff;
      }

  .select-body.on-column li {
    width: 98%;
  }

  .remark-btn {
    width: 200px;
  }
  // .mastered-tip {
  //   position: absolute;
  //   top: 23px;
  //   right: 0;
  //   color: #f44336;
  //   font-size: 12px;
  // }
  .w-picture-card{
    width: 30%;
    // float: left;
    margin-right: 3%;
    position: relative;
    .picture-close{
      position: absolute;
      top: -8px;
      right: -8px;
      background: #ff5254;
      border-radius: 50%;
      color: #fff;
      font-size: 20px;
      cursor: pointer;
    }
    img{
      width: 100%;
    }
  }
  .objectives-btn{
    width: 125px;
    height: 24px;
    border-radius: 9px;
  }
  .pink-text{
    font-size: 12px;
    padding-left: 12px;
  }
</style>
